import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=bd95b758&scoped=true"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"
import style0 from "./ChangePlan.vue?vue&type=style&index=0&id=bd95b758&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd95b758",
  null
  
)

export default component.exports